import { useState } from 'react';
import { useSession } from '../lib/session';
import { supabase } from '../lib/supabase';
import { Halftone } from '../components/Halftone';
import './Subscribe.css';

/**
 * Paywall route for members without active access. Posts CTA to
 * /api/stripe/checkout which returns a hosted checkout URL.
 * Admin/developer/comped users bypass this entirely (see RequireAccess).
 */

export default function Subscribe() {
  const { profile } = useSession();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function startCheckout() {
    setBusy(true);
    setError(null);
    try {
      const { data: sess } = await supabase.auth.getSession();
      const token = sess.session?.access_token;
      if (!token) { setError('Sign in first.'); return; }

      const res = await fetch('/api/stripe/checkout', {
        method: 'POST',
        headers: {
          'content-type': 'application/json',
          authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({}),
      });
      const data = await res.json();
      if (!res.ok || !data?.url) {
        setError(data?.error ?? 'Checkout failed.');
        return;
      }
      window.location.assign(data.url);
    } catch (err: any) {
      setError(err?.message ?? 'Checkout failed.');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="sub">
      <div className="sub__strip">
        <span className="sub__halftone" aria-hidden="true">
          <Halftone type="off-spotlight" />
        </span>
        <div className="sub__inner">
          <p className="kicker sub__kicker">Conversion Club</p>
          <p className="sub__price">
            $15<span className="sub__price-meta">/ month · single tier · cancel anytime</span>
          </p>
          <p className="sub__lede">
            Every new piece, every drawer, every live call. The room behind the Instagram.
          </p>
          <button
            type="button"
            className="btn btn--md sub__cta"
            onClick={startCheckout}
            disabled={busy || !profile}
          >
            {busy ? 'Opening Stripe…' : 'Join the Club'}
          </button>
          {error && <p className="sub__error">{error}</p>}
        </div>
      </div>
    </div>
  );
}
